import Termly from 'termly-namespace'

import ConsentDefaults from 'constants/consentDefaults'

import client from 'utils/client'
import GTM from 'utils/gtm'
import URL from 'utils/url'
import WP from 'utils/wp'

import enableConsentScripts from 'utils/enableConsentScripts'

import {
  getCookie,
  uuidCookie,
} from 'utils/cookie'

import { triggerGetUpdatedCookieWhitelistByTermly } from 'utils/updateCookieConsent'


/**
 * @param {object} args
 * @param {boolean} [args.isTemporary] - true where the caller is unblocking
 *   without storing a consent
 */
export default async function consentAllForScanner({ isTemporary }) {
  if ( Termly.tcf ) {
    // The scanner needs the page unblocked more than it needs a TCF consent
    // string, so nothing in here may stop the calls below from running. Both
    // the chunk and the GVL come off the network, and the caller is the
    // scanner, which does not catch anything we throw.
    try {
      const [
        {
          makeTCModel,
          TCString,
        },
        { data: gvl },
      ] = await Promise.all([
        import('utils/tcf-iab'),
        client.get(URL.fullTcfGVL()),
      ])

      const tcModel = makeTCModel(gvl)
      tcModel.setAll()

      const tcString = TCString.encode(tcModel)

      await Termly.tcf.updateCmpApi(tcString)
    } catch (error) {
      console.error('[Termly] Could not build a TCF consent string for the scanner. '
                    + 'The page will still be unblocked.\n\n%s',
                    error)
    }
  }

  enableConsentScripts({ isTemporary })

  GTM.send(ConsentDefaults.OPT_OUT)
  WP.send(ConsentDefaults.OPT_OUT)

  const optOut = { ...ConsentDefaults.OPT_OUT }

  triggerGetUpdatedCookieWhitelistByTermly({
    consentState: optOut,
    cookieConsent: optOut,
    cookies: Termly.cookies,
    visitorId: getCookie(uuidCookie),
  })
}
